import el from '@finn-no/create-element';
import ModalOverlay from '../lib/ModalOverlay.js';

class PicSearchOverlay extends ModalOverlay {
    _setPosition() {
        super._setPosition();
        Object.assign(this._overlayEle.style, {
            overflowY: 'scroll',
            '-webkit-overflow-scrolling': 'touch',
        });
        this._containerEle.style.position = 'static';
        this._containerEle.style.setProperty('height', '100%', 'important');
    }
}

export default {
    dependencies: ['$element'],
    callable(ele) {
        ele.addEventListener('click', () => openPicSearch());

        function openPicSearch() {
            const id = new URL(document.baseURI).searchParams.get('finnkode');
            const contentEle = showOverlay();
            fetch(`https://www.finn.no/match/ad/mlt/bap/${id}?rows=20`)
                .then(response => response.json())
                .then(json => json.items)
                .then(items => {
                    const ele = el(
                        'div.grid.grid--cols2to3',
                        null,
                        items.map(item =>
                            // TODO: this should use some common template
                            el(
                                'div.grid__unit',
                                null,
                                el(
                                    'a.u-licorice',
                                    { href: item.url },
                                    el(
                                        'div.img-format.img-format--ratio4by3.img-format--centered',
                                        null,
                                        el('img.img-format__img', {
                                            sizes:
                                                '(min-width: 990px) 300px, (min-width: 768px) 33vw, (min-width: 480px) 50vw',
                                            srcset: `
                                                    https://images.finncdn.no/dynamic/480x360c/${item
                                                        .image.url} 480w,
                                                    https://images.finncdn.no/dynamic/240x180c/${item
                                                        .image.url} 240w,
                                                    https://images.finncdn.no/dynamic/320x240c/${item
                                                        .image.url} 320w,
                                                    https://images.finncdn.no/dynamic/640x480c/${item
                                                        .image.url} 640w,
                                                    https://images.finncdn.no/dynamic/960x720c/${item
                                                        .image.url} 960w
                                                `,
                                            src: `https://images.finncdn.no/dynamic/480x360c/${item
                                                .image.url}`,
                                            alt: '',
                                        })
                                    ),
                                    el(
                                        'div.u-t4.u-truncate',
                                        null,
                                        item.heading
                                    )
                                )
                            )
                        )
                    );
                    contentEle.replaceWith(ele);
                })
                .catch(() => {
                    contentEle.replaceWith(
                        el(
                            'p.u-pa16.u-t3.u-bg-salmon',
                            null,
                            'Beklager, det oppsto et problem ved lasting av søkeresultatet. Prøv igjen om litt.'
                        )
                    );
                });
        }

        function showOverlay() {
            const contentEle = el('div.spinner');

            const picSearchOverlay = new PicSearchOverlay(
                'Bildesøk',
                el(
                    'div.u-ph16',
                    { style: 'background: #fff; margin-top: 50vh;' },
                    el(
                        'div.flex.justify-space-between',
                        {
                            style: `
                                position: -webkit-sticky;
                                position: sticky;
                                top: -1px;
                                background: #fff;
                                margin: 0;
                                padding: 10px 0;
                                z-index: 1;
                            `,
                        },
                        el('h2.u-stone', null, 'Bildesøk'),
                        el(
                            'button.button.button--flat',
                            {
                                onclick() {
                                    picSearchOverlay.dismiss();
                                },
                            },
                            el(
                                'svg:svg.u-valign-middle',
                                {
                                    width: '18',
                                    height: '18',
                                    viewBox: '0 0 18 18',
                                },
                                el('svg:path', {
                                    stroke: '#767676',
                                    'stroke-width': '3',
                                    d: 'M2 2l14 14M16 2L2 16',
                                })
                            )
                        )
                    ),
                    contentEle
                ),
                {
                    slide: true,
                }
            );

            picSearchOverlay.show();

            return contentEle;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/picSearchOverlay.js